import { styled } from '@uhg-abyss/web/tools/styled';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const StepDataContainer = styled('div', {
  width: '100%',
});

export const StepIconContainer = styled('div', {
  width: '20px',
  fontSize: '$md',
  fontWeight: 'bold',
  lineHeight: '$md',
  textAlign: 'center',
});

export const StepContainer = styled('div', {
  display: 'flex',
  gap: '8px',
});

export const StepsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const StepsContainter = styled('div', {
  dynamic: ({ cssProps: { mapContainerHeight } = {} }) => ({
    margin: '0 $md',
    minHeight: '80px',
    maxHeight: mapContainerHeight - 230,
    marginBottom: '24px',
    overflowY: 'auto',

    '@media (max-width: 464px)': {
      maxHeight: 'calc(100vh - 434px)',
    },
  }),
});

export const TripLocationContainer = styled('div', {
  display: 'none',

  '@media (max-width: 464px)': {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: 'auto',
    padding: '$md',
  },
});

export const TripLocationDataContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const TripDurationContainer = styled('div', {
  dynamic: ({ cssProps: { isWidget } = {} }) => ({
    flexWrap: isWidget ? 'wrap' : 'nowrap',
  }),
  padding: '4px',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',

  margin: '0 15px',
});

export const DurationDistanceWrapper = styled('div', {
  dynamic: ({ cssProps: { isWidget } = {} }) => ({
    maxWidth: isWidget ? '' : '260px',
    marginRight: isWidget ? '18px' : '',
  }),
  display: 'flex',
  flexWrap: 'wrap',
  gap: '4px',
});

export const DuratonContainer = styled('div', {
  fontWeight: 'bold',
  fontSize: '$md',
  lineHeight: '$md',
  color: '$core.color.neutral.90',
});

export const DistanceContainer = styled('div', {
  fontWeight: 'bold',
  fontSize: '$md',
  lineHeight: '$md',
  color: '$core.color.neutral.90',

  '@media (max-width: 464px)': {
    display: 'none',
  },
});
export const DistanceContainerWidget = styled('div', {
  fontWeight: 'bold',
  fontSize: '$md',
  lineHeight: '$md',
  color: '$core.color.neutral.90',
});

export const RouteInstructionsContainer = styled('div', {});

export const ArrowContainer = styled('div', {
  margin: 'auto',
});

export const SeeDirectionsContainer = styled('button', {
  height: '34px',
  cursor: 'pointer',
  alignItems: 'center',
  display: 'flex',
  padding: '8px 0',
  gap: '4px',
  fontWeight: 'bold',
});

export const HorizontalDivider = styled('div', {
  width: '100%',
  height: '1px',
  boxShadow: '0px 2px 6px 0px #19191A29',
  background: '$core.color.neutral.30',
  marginTop: '0',
});

export const VerticalDivider = styled('div', {
  width: '.5px',
  height: '24px',
  background: '$core.color.neutral.30',
  margin: 'auto',
  border: '0.5px solid $core.color.neutral.30',
});

export const RouteDetailsContainer = styled('div', {
  display: 'none',
  flexDirection: 'column',
  gap: '16px',

  '@media (max-width: 464px)': {
    display: 'flex',
  },
});

export const DetailsContainer = styled('div', {
  background: '$neutralGray2',
  padding: '$md',
  borderRadius: '8px',
  margin: '$md',
});

export const RoutesContainer = styled('div', {
  margin: '0 $md',
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '$sm 0',
  borderBottom: '1px solid $core.color.neutral.30',
});

export const RoutesTabContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  background: '$core.color.neutral.10',
  padding: '0 6px',
  height: '40px',
  borderRadius: '4px',
});

export const RoutesTab = styled('button', {
  fontWeight: 'bold',
  fontSize: '$md',
  lineHeight: '$md',
  color: '$core.color.neutral.60',
  height: '30px',
  padding: '6px 12px',
  borderRadius: '4px',
});

export const MapContainer = styled(Card, {
  dynamic: ({
    cssProps: {
      enableMapEnhancements,
      fullWidth,
      mobileRouteView,
      hasRoute,
      isWidget,
      isGeha,
    } = {},
  }) => ({
    position: 'relative',
    overflow: 'hidden',
    padding: 0,
    width: fullWidth ? '100% !important' : '',
    '@media (max-width: 464px)': {
      height: mobileRouteView
        ? enableMapEnhancements
          ? 'calc(100vh - 60px)'
          : 'calc(100vh - 90px)'
        : '',
      overflowY: isWidget ? 'hidden' : 'auto',
    },
    '.mapboxgl-control-container': {
      display: 'none',
    },
    '.mapboxgl-canvas': {
      '&:focus': {
        outlineColor: '$core.color.brand.60',
        outlineWidth: '2px',
        outlineOffset: '-2px',
        outlineStyle: 'solid',
      },
    },
    '.map-container': {
      position: 'relative',
      height: 'calc(100vh - 125px)',
      '@media (max-width: 464px)': {
        top: mobileRouteView ? '0px' : '',
        height: enableMapEnhancements
          ? 'calc(100vh - 60px)'
          : 'calc(100vh - 90px)',
        width: 'calc(90vh)',
      },
      '@media (max-width: 975px) and (orientation: landscape)': {
        height: '100vh',
      },
      '@media (max-width: 743px) and (orientation: landscape)': {
        height: 'calc(90vh)',
      },
    },
    '.mapboxgl-map': {
      font: 'unset ! important',
    },
    '.map-icon-selected': {
      filter: isGeha
        ? 'brightness(0) saturate(100%) invert(9%) sepia(83%) saturate(6225%) hue-rotate(280deg) brightness(67%) contrast(102%)'
        : 'brightness(0) saturate(100%) invert(20%) sepia(61%) saturate(3769%) hue-rotate(208deg) brightness(91%) contrast(91%)',
      height: '100%',
      width: '100%',
    },
    '.map-icon': {
      filter: isGeha
        ? 'brightness(0) saturate(100%) invert(11%) sepia(62%) saturate(2260%) hue-rotate(241deg) brightness(88%) contrast(116%)'
        : '',
    },

    '.mapboxgl-popup': {
      maxWidth: '100% !important',
      paddingBottom: enableMapEnhancements
        ? '24px !important'
        : '40px !important',
      paddingTop: enableMapEnhancements ? '16px' : '0px',
      display: hasRoute ? 'none' : 'flex',

      '.mapboxgl-popup-content': {
        boxShadow: 'none !important',
        background: 'transparent !important',
        padding: '0 !important',
      },
    },
  }),
});

export const MapDirectionsContainer = styled('div', {
  dynamic: ({ cssProps: { isLocationsTab, mobileScreen } = {} }) => ({
    marginTop: !isLocationsTab && !mobileScreen ? '8px' : '',
  }),
  background: 'white',
});

export const NavigationContainer2 = styled('div', {
  dynamic: ({ cssProps: { isLocationsTab, mobileScreen, hasRoute } = {} }) => ({
    left: hasRoute && mobileScreen ? '0' : '16px',
    top: mobileScreen ? 0 : isLocationsTab ? '$md' : '$lg',
    background: isLocationsTab ? 'white' : '',
  }),
  position: 'absolute',
  zIndex: 1,
  '@media (max-width: 744px)': {
    border: '0',
    borderRadius: '0',
    fontFamily: '$heading',
    left: 0,
    overflowY: 'hidden',
    position: 'absolute',
    top: 0,
    width: '100%',
  },
  '@media (max-width: 464px)': {
    maxWidth: '100%',
  },
});

export const NavigationContainer = styled('div', {
  dynamic: ({ cssProps: { hasRoute, enableMapEnhancements } = {} }) => ({
    background: hasRoute ? 'white' : 'transparent',
    boxShadow: hasRoute ? '0px 2px 6px rgba(25, 25, 26, 0.16)' : 'none',
    display: enableMapEnhancements && !hasRoute ? 'flex' : 'block',
    maxWidth: enableMapEnhancements && !hasRoute ? '' : '408px',
    top: enableMapEnhancements ? '50px' : '$lg',
    left: enableMapEnhancements ? (hasRoute ? '0' : '16px') : '85px',
  }),
  position: 'absolute',
  zIndex: 1,

  '@media (max-width: 744px)': {
    border: '0',
    borderRadius: '0',
    fontFamily: '$heading',
    left: 0,
    overflowY: 'hidden',
    position: 'absolute',
    top: 0,
    width: '100%',
  },
  '@media (max-width: 464px)': {
    maxWidth: '100%',
  },
});

export const MapCarousel = styled('div', {
  '.abyss-carousel-root': {
    width: '408px',
    '@media (max-width: 464px)': {
      width: '320px',
    },
  },
  '.abyss-carousel-controls': {
    width: '220px !important',
    borderRadius: ' 0px 0px 8px 8px',
    backgroundColor: 'white',
    margin: 'auto',
    display: 'none',
  },
  '.abyss-slide-container': {
    backgroundColor: 'transparent',
  },
  '.abyss-carousel-nav-container-right': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },
  'abyss-carousel-nav-container-left': {
    width: '20px',
    height: '20px',
    padding: '0px',
    top: '-3px',
  },
});

export const MapControlContainer = styled(Flex, {
  dynamic: ({ cssProps: { alertVisible, mobileScreen } = {} }) => ({
    top: alertVisible ? (mobileScreen ? '115px !important' : '90px') : '$md',
    '@media (max-width: 1350px)': {
      top: alertVisible ? '135px' : '$md',
    },
  }),
  gap: '12px',
  position: 'absolute',
  zIndex: 1,
  transition: 'top 0.3s ease-in-out',
});

export const ZoomButton = styled(Flex, {
  background: '$core.color.neutral.0',
  width: '48px',
  height: '88px',
  borderRadius: '100px',
  gap: '$md',
  padding: '3px 0',
});

export const SmartChoiceAlertContainer = styled('div', {
  left: '0',
  right: '0',
  top: '0',
  padding: '0',
  position: 'absolute',
  zIndex: 2,
});
